const KLAVIYO_BASE_URL = 'https://a.klaviyo.com/client'
const KLAVIYO_PUBLIC_API_KEY = process.env.NEXT_PUBLIC_KLAVIYO_PUBLIC_KEY
const KLAVIYO_NEWSLETTER_LIST = 'UPQmxX'

export const subscribeToBackInStock = async (email: string, variantId: string) => {
  const response = await fetch(
    `${KLAVIYO_BASE_URL}/back-in-stock-subscriptions?company_id=${KLAVIYO_PUBLIC_API_KEY}`,
    {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        revision: '2024-06-15',
      },
      body: JSON.stringify({
        data: {
          type: 'back-in-stock-subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  email: email,
                },
              },
            },
            channels: ['EMAIL'],
          },
          relationships: {
            variant: {
              data: {
                type: 'catalog-variant',
                id: `$shopify:::$default:::${variantId}`,
              },
            },
          },
        },
      }),
    },
  )

  if (!response.ok) {
    throw new Error('Failed to subscribe to back in stock notifications')
  }
}

export const subscribeToNewsletter = async (email: string) => {
  const response = await fetch(
    `${KLAVIYO_BASE_URL}/subscriptions?company_id=${KLAVIYO_PUBLIC_API_KEY}`,
    {
      method: 'POST',
      headers: {
        accept: 'application/vnd.api+json',
        revision: '2025-07-15',
        'content-type': 'application/vnd.api+json',
      },
      body: JSON.stringify({
        data: {
          type: 'subscription',
          attributes: {
            profile: {
              data: {
                type: 'profile',
                attributes: {
                  subscriptions: {
                    email: {
                      marketing: {
                        consent: 'SUBSCRIBED',
                      },
                    },
                  },
                  email: email,
                },
                id: 'string',
              },
            },
            custom_source: 'Produkt Ausverkauft Subscribe',
          },
          relationships: {
            list: {
              data: {
                type: 'list',
                id: KLAVIYO_NEWSLETTER_LIST,
              },
            },
          },
        },
      }),
    },
  )

  if (!response.ok) {
    throw new Error('Failed to subscribe to newsletter')
  }
}
